import { render, staticRenderFns } from "./IconTriangleLeft.vue?vue&type=template&id=def6dab4&"
import script from "./IconTriangleLeft.vue?vue&type=script&lang=js&"
export * from "./IconTriangleLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports